import { RESIDENT_STATUS_FILTERS, WITHOUT_SUBCATEGORY_FILTER } from "../model/administrationConstants";
import { primaryButtonStyle, secondaryButtonStyle } from "../styles/administrationModalStyles";
import { inputStyle, labelStyle, toolbarStyle } from "../styles/administrationStyles";

export function renderResidentToolbar(view) {
    const { ehpadId, ehpads, loadedPatientCount, openReportModal, patientTotal, residentStatusFilter, residentSubcategoryFilter, search, selectedEhpad, selectedEhpadSubcategories, setAddPatientOpen, setEhpadId, setResidentStatusFilter, setResidentSubcategoryFilter, setSearch } = view;
    return (
    <div style={toolbarStyle}>
        <label style={labelStyle}>
            <span>EHPAD</span>
            <select
                style={{ ...inputStyle, minWidth: "240px" }}
                value={ehpadId}
                onChange={event => {
                    setEhpadId(event.target.value);
                    setResidentSubcategoryFilter("");
                }}
            >
                {ehpads.length === 0 && <option value="">Aucun EHPAD</option>}
                {ehpads.map(ehpad => <option key={ehpad.id} value={ehpad.id}>{ehpad.nom}</option>)}
            </select>
        </label>
        {selectedEhpad && (
            <label style={labelStyle}>
                <span>Sous-groupe</span>
                <select
                    style={{ ...inputStyle, minWidth: "180px" }}
                    value={residentSubcategoryFilter}
                    onChange={event => setResidentSubcategoryFilter(event.target.value)}
                >
                    <option value="">Tous les sous-groupes</option>
                    <option value={WITHOUT_SUBCATEGORY_FILTER}>Patients sans sous catégorie</option>
                    {selectedEhpadSubcategories.map(subcategory => (
                        <option key={subcategory} value={subcategory}>{subcategory}</option>
                    ))}
                </select>
            </label>
        )}
        <label style={labelStyle}>
            <span>Rechercher un résident</span>
            <input
                style={{ ...inputStyle, minWidth: "260px" }}
                type="search"
                placeholder="Nom, prénom ou chambre"
                value={search}
                onChange={event => setSearch(event.target.value)}
            />
        </label>
        <label style={labelStyle}>
            <span>Statut</span>
            <select
                style={{ ...inputStyle, minWidth: "150px" }}
                value={residentStatusFilter}
                onChange={event => setResidentStatusFilter(event.target.value)}
            >
                {RESIDENT_STATUS_FILTERS.map(([value, label]) => (
                    <option key={value} value={value}>{label}</option>
                ))}
            </select>
        </label>
        <span style={{ color: "#6b7280", alignSelf: "end", paddingBottom: "8px" }}>
            {loadedPatientCount < patientTotal
                ? `${loadedPatientCount}/${patientTotal} résident(s) chargés`
                : `${patientTotal} résident(s)`}
        </span>
        <button
            type="button"
            disabled={!ehpadId}
            onClick={openReportModal}
            style={{ ...secondaryButtonStyle, alignSelf: "end" }}
        >
            Télécharger
        </button>
        <button
            type="button"
            disabled={!ehpadId}
            onClick={() => setAddPatientOpen(true)}
            style={{ ...primaryButtonStyle, alignSelf: "end" }}
        >
            Ajouter un patient
        </button>
    </div>
    );
}
